
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// import jwtInterceptor from "../Shared/jwtInterceptor";
// import axios from "axios";
import store from "../../store/index";
export default {
  name: "viewTemplate",
  props: {
    isPatientVisit: Boolean,
    template: String,
    study: String,
    visitid: String,
    // scheduledvisit: { 
    //   type: Object,
    //   default: () => ({})
    // }
  },
   data() {
    return {
      envvar: process.env.NODE_ENV,
      localScheduledVisit: {},
      templateId: "",
      stdyid: "",
      visitids: "",
      saveactive: true,
      ispatientvalue: false,
      previousRoute: null,
      extraData: null,
       isLoaded: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Inside next(vm => …), `vm` is the component instance, so we can assign `from`.
      vm.previousRoute = {
        name: from.name || null,
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.fullPath != "/submitForm") {
      store.dispatch("setopentreeforsubmitForm", false);
    }
    if (to.fullPath != "/subject_schedule") {
      store.dispatch("setopentreeforsubjectschedule", false);
    }
    if (to.fullPath != "/eproSubjects") {
      store.dispatch("setopentreeforeprosubjects", false);
    }
    next()
  },
  mounted() {
    console.log('this.previousRoute is ', this.previousRoute.name);
    //subject_schedule
    if (this.previousRoute.name == "submitForm") {
      store.dispatch("setopentreeforsubmitForm", true);
    }
    if (this.previousRoute.name == "subject_schedule") {
      store.dispatch("setopentreeforsubjectschedule", true);

    }
    if (this.previousRoute.name == "eproSubjects") {
      console.log("entered")
      store.dispatch("setopentreeforeprosubjects", true);
    }

  },
  async beforeMount() {
  await this.setTempId();
  
  if (this.$route.query.tempObj) {
    const decoded = JSON.parse(decodeURIComponent(this.$route.query.tempObj));
    this.extraData = decoded;

    const visitDetails = localStorage.getItem("visitDetails");
    this.localScheduledVisit = JSON.parse(visitDetails);

   // this.isLoaded = true;   // <-- important
    console.log('localScheduledVisit is ', this.localScheduledVisit);
  }
}
,
 
  methods: {
    async setTempId() {
      this.templateId = this.template;
      this.stdyid = this.study;
      this.visitids = this.visitid;
      this.ispatientvalue = this.isPatientVisit
    },
    onclosed() {
      // this.$router.push(`/visitforms`);
      this.$router.go(-1);
    }

  },
};